import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BookFlightState } from "./types";
import { ErrorType } from "@/shared/types";
import { fetchFlight } from "./book-flight-thunk";
import { DocumentType } from "@/shared/api/aviabooking";

const initialState: BookFlightState = {
    isLoading: false,
    error: null,
    loadedFlightId: null,
    flight: {
        id: "",
        segments: [],
        dep_airport_code: "",
        arr_airport_code: "",
        total_duration: 0,
        expected_ticket_count: 0,
        type_info: {
            type: DocumentType.Unspecified,
            direction_type: "",
            multy_ow_leg: false,
            has_supplier_virtual_inline: false
        },
        prices: [],
        mandatory_latin_names: false,
        fare_families_descs: [],
        business_rules: []
    },
    segmentsMap: {},
    priceMap: {},
    seatMap: {
        segments: []
    },
    fareFamiliesFlights: [],
    selectedFareFamilyFlightId: null,
}

const bookFlightSlice = createSlice({
    name: 'bookFlight',
    initialState,
    reducers: {
        setSelectedFareFamilyFlightId(state, action: PayloadAction<string | null>) {
            state.selectedFareFamilyFlightId = action.payload
        }
    },
    extraReducers(builder) {
        builder
        .addCase(fetchFlight.pending, (state) => {
            state.isLoading = true
        })
        .addCase(fetchFlight.fulfilled, (state, action) => {
            state.flight = action.payload.actualized_flight
            state.loadedFlightId = action.meta.arg
            state.error = null
            state.isLoading = false
            state.fareFamiliesFlights = action.payload.fare_families_flights
            state.seatMap = action.payload.seat_map
            state.selectedFareFamilyFlightId = null
            action.payload.actualized_flight.segments.forEach((segment) => {
                state.segmentsMap = {...state.segmentsMap, [segment.id]: segment }
            })
            action.payload.actualized_flight.prices.forEach((price) => {
                state.priceMap = {...state.priceMap, [price.id]: price }
            })
        })
        .addCase(fetchFlight.rejected, (state, action) => {
            state.error = action.payload as ErrorType
            state.loadedFlightId = null
            state.isLoading = false
        })
    },
})

export const { setSelectedFareFamilyFlightId } = bookFlightSlice.actions
export default bookFlightSlice.reducer